import { usePotentialBookingFiltersContext } from '@sales-app/context/potentialBookingFilters/potentialBookingFilters'
import {
  LengthOfStayBucket,
  lengthOfStayBucketLabel,
  lengthOfStayBucketOptions,
} from '@sales-app/context/workspace/lengthOfStayBucket.util'
import React, { useState } from 'react'

import { Dropdown } from '@/components'
import { FilterOptionsStyled } from '@/components/ListFilter/FilterOptionsStyled'

export const LengthOfStayFilter = () => {
  const { lengthOfStayBucket, setFilters } = usePotentialBookingFiltersContext()

  const [dropdownExpanded, setDropdownExpanded] = useState(false)

  const handleCancel = () => {
    setDropdownExpanded(false)
  }

  const changeFilter = (val: LengthOfStayBucket | null = null) => {
    setDropdownExpanded(false)
    setFilters({ lengthOfStayBucket: val })
  }

  const headerTitle = lengthOfStayBucket ? lengthOfStayBucketLabel(lengthOfStayBucket) : 'Length of Stay'

  return (
    <Dropdown
      className="hidden w-full md:w-auto lg:flex"
      expanded={dropdownExpanded}
      headerTitle={headerTitle}
      onHideDropdown={handleCancel}
      renderHeader={() => <div></div>}
      selected={!!lengthOfStayBucket}
      setExpanded={setDropdownExpanded}
    >
      <FilterOptionsStyled>
        <div className="flex max-h-48 min-h-24 w-full overflow-scroll">
          <ul>
            <li
              className={`${!lengthOfStayBucket ? 'selected' : ''}`}
              onClick={() => changeFilter()}
              role={'presentation'}
            >
              All
            </li>
            {lengthOfStayBucketOptions.map((option) => (
              <li
                className={`${lengthOfStayBucket === option.value ? 'selected' : ''}`}
                key={option.value}
                onClick={() => changeFilter(option.value)}
                role={'presentation'}
              >
                {option.label}
              </li>
            ))}
          </ul>
        </div>
      </FilterOptionsStyled>
    </Dropdown>
  )
}
